import React, { useState, useEffect } from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setAllChecked, setAllCheckedLocal, updateQuantityTableLocal, updateQuantityTable, setCheckedFlow, setCheckedFlowLocal } from "../../redux/actions/analysisActions";

import { setUserOnboardingStep, setUserOnboardingStepLocal } from "../../redux/actions/userActions";
import { Tooltip } from "@mui/material";

const LineColumns = ({ columns, quantity, quantityUnit, totalScore, impact_factors, conversion_factor, checked, step, line_index, flow_id, is_reduce, k_type }) => {
  // REDUX
  const dispatch = useDispatch();
  const updateQuantityTable_rd = (item) => dispatch(updateQuantityTable(item));
  const updateQuantityTableLocal_rd = (item) => dispatch(updateQuantityTableLocal(item));
  const setCheckedFlow_rd = (item) => dispatch(setCheckedFlow(item));
  const setCheckedFlowLocal_rd = (item) => dispatch(setCheckedFlowLocal(item));
  const setAllChecked_rd = (item) => dispatch(setAllChecked(item));
  const setAllCheckedLocal_rd = (item) => dispatch(setAllCheckedLocal(item));
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual);
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual);
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));
  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };

  const handleOnChangeQuantity = (event, previous_quantity) => {
    const item = {
      analysis_id: analysis_id,
      flow_id: flow_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: event.target.value, // acutual quantity value
      previous_quantity: previous_quantity,
      is_proxy: Math.abs(step - 6) === 4 && !analysis_data.ingredients ? true : false,
      type: "flow_quantity",
      k_type: k_type,
    };

    updateQuantityTableLocal_rd(item);
    updateQuantityTable_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      console.log("changeonboarding");
      handleChangeOnboardingStep(2);
    }
  };

  const handleOnChangeChecked = (is_proxy) => {
    const item = {
      analysis_id: analysis_id,
      flow_id: flow_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      value: !checked,
      type: "update_checked",
      is_proxy: is_proxy,
      k_type: k_type,
    };
    console.log("item", item);
    setCheckedFlowLocal_rd(item);
    setCheckedFlow_rd(item);

    const all_checked = Object.values(analysis_data.lca.lca_steps).every((x) => {
      return (
        x.input &&
        Object.values(x.inputs).every((x) => {
          return x.checked;
        })
      );
    });
    // if (all_checked && analysis_id) {
    //   setAllChecked_rd({ analysis_id: analysis_id, status: "completed" });
    //   setAllCheckedLocal_rd({ analysis_id: analysis_id, status: "completed" });
    // } else if (!all_checked && analysis_id) {
    //   setAllChecked_rd({ analysis_id: analysis_id, status: "onGoing" });
    //   setAllCheckedLocal_rd({ analysis_id: analysis_id, status: "onGoing" });
    // }

    // // update onboarding step
    // if (user_info.usage_info && user_info.usage_info.onboarding_step < 3) {
    //   console.log("changeonboarding");
    //   handleChangeOnboardingStep(3);
    // }
  };

  const get_impact = (analysis_data, indicator_id) => {
    let transports_impact = 0;
    // let indicator_unit;
    if (step === 2) {
      //////////// get transport impact
      if (analysis_data.ingredients && analysis_data.ingredients[flow_id] && !analysis_data.ingredients[flow_id].name) {
        const transports_data = Object.values(analysis_data.ingredients[flow_id]).find((x) => x.category.name === "K_Transports");
        if (transports_data) {
          const transports_data_inputs = Object.values(transports_data.inputs).filter((x) => x.flow.category.name === "K_Transports");
          transports_impact = Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
            const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
            const indicator_coefficient = indicator.coefficient;
            const amount = currentValue.amount;
            const conversion_factor = currentValue.unit.conversion_factor;
            return accumulator + indicator_coefficient * amount * conversion_factor;
          }, 0);
        }
        //////////// get ingredient impact
        const ingredient = Object.values(Object.values(analysis_data.lca.lca_steps)[6 - step].inputs)[line_index];
        const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === indicator_id);
        const ingredient_impact = ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient;
        transports_impact = transports_impact + ingredient_impact;
      } else {
        transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
      }
    } else {
      // flow impact
      transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
    }
    return transports_impact;
    // return 10;
  };

  const get_impact_optimization = (indicator_id, analysis_data) => {
    let transports_impact = 0;
    // let indicator_unit;
    if (step === 2) {
      //////////// get receip impact
      if (analysis_data.ingredients && !analysis_data.ingredients[flow_id].name) {
        // if ingredients

        // get transports categories
        const transports_data = Object.values(analysis_data.ingredients[flow_id]).find((x) => x.category.name === "K_Transports");

        if (transports_data && transports_data.inputs) {
          // filter optimization
          const opt_inputs = Object.values(transports_data.inputs).filter((x) => x.optimization_results);

          transports_impact =
            transports_impact +
            Object.values(opt_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator.coefficient;
              const amount = currentValue.optimization_results.amount;
              const conversion_factor = currentValue.optimization_results.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);

          const nomal_inputs = Object.values(transports_data.inputs).filter((x) => !x.optimization_results);
          const transports_data_inputs = Object.values(nomal_inputs).filter((x) => x.flow.category.name === "K_Transports");
          transports_impact =
            transports_impact +
            Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator.coefficient;
              const amount = currentValue.amount;
              const conversion_factor = currentValue.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);
        }

        // //////////// get ingredient impact
        const ingredient = Object.values(Object.values(analysis_data.lca.lca_steps)[6 - step].inputs)[line_index];
        const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === indicator_id);
        const ingredient_impact = ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient;
        transports_impact = transports_impact + ingredient_impact;
      } else {
        console.log(
          "impact_factors",
          impact_factors,
          indicator_id,
          impact_factors.find((i) => i.id === indicator_id)
        );
        transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
      }
    } else {
      transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
    }

    return parseFloat(transports_impact).toFixed(2);
  };

  const [impactt, setImpactt] = useState(null);

  useEffect(() => {
    const calc_fn = async () => {
      setImpactt(
        ((is_reduce ? get_impact_optimization("da32f256-618d-4bec-a8d9-205817788b26", optimization_data) : get_impact(analysis_data, "da32f256-618d-4bec-a8d9-205817788b26")) / totalScore) * 100
      );
    };
    calc_fn();
  }, [totalScore]);

  return (
    <>
      <Tooltip title={quantity} arrow>
        <div className={"flex grid grid-cols-[70px_40px] justify-center items-center h-[40px] w-[140px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular"}>
          <p>
            <input
              disabled={user_info && (is_reduce ? true : user_info.organization_info.role.access.analyse.write ? false : true)}
              type="number"
              className="w-[60px] bg-transparent text-right flex mr-1"
              onChange={(event) => handleOnChangeQuantity(event, quantity)}
              value={quantity}
              onWheel={(e) => e.target.blur()}
            />{" "}
          </p>
          <div>{quantityUnit}</div>
        </div>
      </Tooltip>

      <div className={`flex justify-evenly items-center h-[40px]  w-[140px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}>
        <div className="h-[40px] w-[54.5px] flex justify-end items-center">
          <p className="mr-[10px]">{isNaN(impactt) ? "-" : impactt && impactt.toFixed(2)}</p>
        </div>
        <div className="w-[60px] h-[5px] bg-[#BEC4CA]/50 rounded-xl mr-[5px] flex justify-start">
          <div style={{ width: impactt && impactt }} className={`w-[${impactt}%] h-[5px] rounded-xl bg-[#BEC4CA]`} />
        </div>
      </div>

      {/* <p
        onClick={() => {
          const ingredient = Object.values(Object.values(analysis_data.lca.lca_steps)[6 - step].inputs)[line_index];
        const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === "da32f256-618d-4bec-a8d9-205817788b26");
        const ingredient_impact = ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient;
        console.log('ingredient_impact', get_impact(analysis_data, "da32f256-618d-4bec-a8d9-205817788b26"))
        // transports_impact = transports_impact + ingredient_impact;
        }}
      >
        DEBUG
      </p> */}

      {columns.map((current, i) => {
        const indicator_impact = is_reduce ? get_impact_optimization(current, optimization_data) : get_impact(analysis_data, current);
        const indicator_unit = impact_indicators.find((target) => target.id === current).ref_unit;
        const width = impact_indicators.find((target) => target.id === current).width;
        return (
          <>
            <div className={`flex justify-center items-center h-[40px]  w-[${width && width}px]  border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}>
              <Tooltip title={isNaN(indicator_impact) ? "-" : indicator_impact + " " + indicator_unit} arrow>
                <p>
                  {isNaN(indicator_impact) ? "-" : parseFloat(indicator_impact).toExponential(2)} {" " + indicator_unit}
                </p>
              </Tooltip>
            </div>
          </>
        );
      })}

      <div className={`flex justify-center items-center h-[40px]  w-[100px] border-dotted border-[0.1px] border-[#F3F5F7] text-sm font-Poppins-Regular`}>
        <button
          className={user_info.organization_info.role.access.analyse.write && (is_reduce ? "cursor-default" : "")}
          onClick={() => {
            if (user_info.organization_info.role.access.analyse.write && !is_reduce) {
              handleOnChangeChecked(analysis_data.ingredients ? false : true);
            }
          }}
        >
          {checked ? <Checked height={30} /> : <Unchecked height={30} />}
        </button>
      </div>
    </>
  );
};

export default LineColumns;
